// List of component names kept on one place. Useful for components' `displayName` and for testing purposes
// (names serve as a prefix for all components' IDs).
export var CMP_ACTION_ITEMS = 'ActionItems';
export var CMP_ADD_VIEW_DIALOG = 'AddViewDialog';
export var CMP_CONFIGURATION_MENU = 'ConfigurationMenu';
export var CMP_CONTEXT_MENU_ITEM = 'ContextMenuItem';
export var CMP_DETAIL_ACTIONS = 'DetailActions';
export var CMP_DETAIL_HEADER = 'DetailHeader';
export var CMP_DETAIL_VIEW = 'DetailView';
export var CMP_EDIT_VIEWS_DIALOG = 'EditViewsDialog';
export var CMP_ICON_RENDERER = 'IconRenderer';
export var CMP_LIST_HEADER = 'ListHeader';
export var CMP_LIST_TABLE = 'ListTable';
export var CMP_LIST_VIEW = 'ListView';
export var CMP_LOADING_OR_EMPTY_STATE = 'LoadingOrEmptyState';
export var CMP_SAVED_VIEW = 'SavedView';
export var CMP_SAVED_VIEWS_FILTER = 'SavedViewsFilter';
export var CMP_SPLITTER_VIEW = 'SplitterView';
export var CMP_FILTER_MENU = 'FilterMenu';
export var CMP_FILTER_MENU_ITEM = 'FilterMenuItem';
//# sourceMappingURL=componentNames.js.map